import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/js/rem';
import './icons';

// axios
import axios from 'axios';
Vue.prototype.$axios = axios;
import qs from 'qs';
Vue.prototype.$qs = qs;

import SignCanvas from 'sign-canvas';
Vue.use(SignCanvas);

// ElementUI
import ElementUI, { Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/less/theme/index.css';
Vue.use(ElementUI);
import { myMessage } from '../src/assets/js/resetMessage';
// 注意：挂载自定义$message必须放在Vue.use(ElementUI)后面，才能覆盖element-ui默认的message，不然没有效果
Vue.prototype.$message = myMessage;
//el-table表格删除数据后，el-pagination自动向前翻页
// import { AutoPageForward } from './assets/js/AutoPageForward';
// Vue.component(Pagination.name, AutoPageForward(Pagination));

import { QiisChart } from './assets/js/echarts';
Vue.prototype.QiisChart = QiisChart;

// 引入外部 js 方法 文件
import { common, DynamicBoxLayout, alias, reviewUrl,report } from './assets/js/common';
Vue.prototype.common = common;
Vue.prototype.alias = alias;
Vue.prototype.reviewUrl = reviewUrl;
Vue.prototype.report = report;
Vue.prototype.DynamicBoxLayout = DynamicBoxLayout;

// 隐藏滚轮 插件
import VueSmoothScroll from 'vue2-smooth-scroll';
Vue.use(VueSmoothScroll);

// 解析tokennpm
import jwt_decode from 'jwt-decode';

// 截图插件
import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

// 图片预览组件
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
Vue.use(VueViewer);

import FloatingButton from './components/FloatingButton.vue';
Vue.component('FloatingButton', FloatingButton);

import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
Vue.prototype.$VXETable = VXETable;

Vue.use(VXETable);

// 拦截处理
Vue.config.productionTip = false;
axios.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      if (config.headers.post['Content-Type'] !== 'multipart/form-data') {
        // qs.stringify处理拦截
        let ifQs = true;
        let urlArr_noQs = [
          'examination/addExamination',
          'question/addEvaluation',
          'question/addQuestion',
          'user/register',
          'user/registerOther',
          'user/registerExpert',
          'industry/addIndustry',
          'reviewRecord/addRecord',
          'reviewRecord/distributionSpecialist',
          'selfAssessment/startSelfAssessmentList',
          'review/startReview',
          'company/submit'
        ];
        urlArr_noQs.forEach((item) => {
          if (config.url.indexOf(item) > 0) {
            ifQs = false;
          }
        });
        if (ifQs) {
          config.data = qs.stringify(config.data);
        }
      } else {
        config.data = config.data;
      }
    }
    let token_cookie = sessionStorage.getItem(`userToken`);
    if (token_cookie) {
      config.headers.token = token_cookie;
      if (config.url.indexOf('/login') < 0 && config.url.indexOf('/app/updateToken') < 0) {
        let nowDate = new Date().getTime();
        if (jwt_decode(token_cookie).exp * 1000 - nowDate < 3600000) {
          //token到期获取新token再进行页面加载
          common.getNewToken();
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);
axios.interceptors.response.use((response) => {
  if (response.data.code === 500 && response.data.msg.indexOf('token') > -1) {
    if (Vue.productionTip) {
    } else {
      Vue.productionTip = true;
      ElementUI.Message({
        type: 'error',
        message: 'token不能为空',
        offset: 80,
      });
      localStorage.clear();
      sessionStorage.clear();
      router.replace({
        path: '404', // token失效到登录页
      });
    }
  }
  // 判断是否刷新用户信息
  if (response.headers.ismodified != undefined || response.headers.isModified != undefined) {
    store.commit('setIsModified', true);
  }
  return response;
});

/*使用VueResource插件*/
import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.interceptors.push((request, next) => {
  let token = sessionStorage.getItem(`${alias}token`);
  if (token) {
    request.headers.set('token', token);
  }
  let timeout;
  // 如果某个请求设置了_timeout,那么超过该时间，会终端该（abort）请求,并执行请求设置的钩子函数onTimeout方法，不会执行then方法。
  if (request._timeout) {
    timeout = setTimeout(() => {
      if (request.onTimeout) {
        request.onTimeout(request);
        request.abort();
      }
    }, request._timeout);
  }
  next(function (response) {
    if (response.data != null && response.data.code === 500 && response.data.msg.indexOf('token') > -1) {
      ElementUI.Message({
        type: 'error',
        message: 'token不能为空',
        offset: 80,
      });
      sessionStorage.clear();
      router.replace({
        path: '404', // token失效到登录页
      });
    }
    clearTimeout(timeout);
    return response;
  });
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
